export default "__VITE_ASSET__CiQ9snNl__"